import { Component, Input, OnInit } from '@angular/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { IntegrationsService } from '@app/modules/site-settings-integrations/services/integrations.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payzaar-run-now',
  templateUrl: './payzaar-run-now.component.html',
  styleUrls: ['./payzaar-run-now.component.scss']
})
export class PayzaarRunNowComponent implements OnInit {
  @Input() integrationId: string;
  isRunning: boolean = false;

  constructor(
    private integrationService: IntegrationsService,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  runNow() {
    this.overlayService.show();

    this.integrationService.runNowPayzaar(this.integrationId).subscribe({
      next: () => {
        this.isRunning = true;
        setTimeout(() => {
          this.isRunning = false;
        }, 30000);
        this.overlayService.hide();
        this.snackbarService.openSnackBar(this.translate.instant('IntegrationConfigUpdated'), 'clear', 'success');
      },
      error: () => {
        this.overlayService.hide();
      }
    })
  }

}
